<template>
  <div class="has-text-primary is-flex referral-options">
    <DesktopFacebookPostReferral
      :is-loading="isLoadingFacebookScript"
      :referral-link="referralLink"
    />
    <DesktopFacebookPrivateMessageReferral
      :is-loading="isLoadingFacebookScript"
      :referral-link="referralLink"
    />
    <DesktopMailReferral :referral-link="referralLink" />
  </div>
</template>

<script>
import { LoadFacebookSDKMixin } from '/@/modules/platformreferral/mixins/LoadFacebookSDKMixin';
import DesktopFacebookPrivateMessageReferral from '/@/modules/platformreferral/components/DesktopFacebookPrivateMessageReferral.vue';
import DesktopFacebookPostReferral from '/@/modules/platformreferral/components/DesktopFacebookPostReferral.vue';
import DesktopMailReferral from '/@/modules/platformreferral/components/DesktopMailReferral.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'DesktopReferralOptions',
  mixins: [LoadFacebookSDKMixin],
  components: {
    DesktopMailReferral,
    DesktopFacebookPrivateMessageReferral,
    DesktopFacebookPostReferral
  },
  props: {
    referralLink: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.referral-options {
  gap: var(--ce-30px);
}
</style>
